import { ContentType, SectionBaseModel } from '@/components/layout/section/SectionBaseModel';
import { SdkAddonRegistration } from './addons/registration';
import { SdkFormFieldModel } from './formField';
import { SdkRowModel } from './row';

export class SdkBaseSectionModel {
  #model: SectionBaseModel;

  constructor(model: SectionBaseModel) {
    this.#model = model;
  }

  public get rows() {
    if (this.#model.state.content[0] && this.#model.state.content[0].type === ContentType.GRID) {
      return this.#model.state.content[0].rows.map((row) => new SdkRowModel(row));
    } else {
      throw new Error('[SDK] Not able to find any rows on the section');
    }
  }

  public get formFields(): SdkFormFieldModel[] {
    const formFields: SdkFormFieldModel[] = [];

    this.rows.forEach((row) => {
      row.Columns.forEach((column) => {
        column.addons.forEach((addon) => {
          if (addon instanceof SdkAddonRegistration) {
            formFields.push(...addon.formFields);
          }
        });
      });
    });

    return formFields;
  }

  public get id(): number {
    return this.#model.state.id;
  }

  public get title(): string | undefined {
    return this.#model.state.title;
  }
}
